import {ErrorHandler, Injectable, Injector, NgZone, OnDestroy} from "@angular/core";
import {DialogService} from "@progress/kendo-angular-dialog";
import {throwError} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import {take} from "rxjs/operators";
import {MsError} from "../fw/helpers/MsError";
import {MessageComponent} from "./shared/message.component";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler, OnDestroy {
    constructor(private injector: Injector) { }

    ngOnDestroy() {
    }

    handleError(error: Error | HttpErrorResponse) {
        const dialogService = this.injector.get(DialogService);
        const ngZone = this.injector.get(NgZone);
        ngZone.run(() => {
            let msError = new MsError();
            msError.errorNumber = 1000;
            msError.friendlyMessage = 'Er is een onbekende fout opgetreden';
            if (error instanceof HttpErrorResponse) {
                if (!navigator.onLine) {
                    msError.errorNumber = 1001;
                    msError.friendlyMessage = 'U heeft geen verbinding met het internet';
                    msError.message = 'No internet connection';
                } else {
                    msError.errorNumber = 1002;
                    msError.message = error.message;
                    msError.status = error.status;
                    msError.statusText = error.statusText;
                }
                const dialogRef = dialogService.open({
                    content: MessageComponent
                });

                const dialogContent: MessageComponent = dialogRef.content.instance;
                dialogContent.dialog = dialogRef;
                dialogContent.message = msError.friendlyMessage;
                dialogRef.result.pipe(take(1)).subscribe();
            } else {
                msError.errorNumber = 1003;
                msError.message = error.message;
            }

            //if (!environment.production) {
                console.error(msError);
            //}

            return throwError(error);
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/GlobalErrorHandler.ts